
import { Link } from 'react-router-dom';

export default function Footer() {
  const navigation = {
    company: [
      { name: '企業情報', href: '/about' },
      { name: 'サービス', href: '/services' }
    ],
    support: [
      { name: 'お問い合わせ', href: '/contact' },
      { name: 'よくある質問', href: '/faq' },
      { name: 'プライバシーポリシー', href: '/privacy' },
      { name: '利用規約', href: '/terms' }
    ],
    social: [
      { name: 'Twitter', href: '#', icon: 'ri-twitter-x-fill' },
      { name: 'Facebook', href: '#', icon: 'ri-facebook-fill' },
      { name: 'LinkedIn', href: '#', icon: 'ri-linkedin-fill' },
      { name: 'Instagram', href: '#', icon: 'ri-instagram-fill' }
    ]
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
                logo
              </div>
            </div>
            <p className="text-gray-600 mb-4">
              人材育成で組織の未来を創る。実践的な研修・講座で、個人と組織の成長をサポートします。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">サービス</h3>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-gray-600 hover:text-blue-600 transition-colors">サービス</Link></li>
              <li><Link to="/cases" className="text-gray-600 hover:text-blue-600 transition-colors">事例紹介</Link></li>
              <li><Link to="/news" className="text-gray-600 hover:text-blue-600 transition-colors">お知らせ</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-blue-600 transition-colors">お問い合わせ</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">会社情報</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-600 hover:text-blue-600 transition-colors">企業概要</Link></li>
              <li><a href="mailto:info@oyside.com" className="text-gray-600 hover:text-blue-600 transition-colors">お問い合わせ</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Onyourside. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer mt-2 sm:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}